<div class="bn-alert-notice bn-attention-notice" *ngIf="!hideAlert">
    <div class="bn-icon">
        <img src="./assets/img/images/attention-icon-warning-32.svg" alt="warning icon" />
    </div>
    <div class="bn-content">
        <div class="bn-content-text">
            <div class="bn-content-text-sub">
                <div class="bn-content-text-title">Attention</div>
                <div class="bn-content-close">
                    <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                        (click)="onClose()" />
                </div>
            </div>
            <ng-container *ngIf="autoPayAlert; else notAutoPayAlert">
                <div>
                    <div class="bn-desc-text">An automatic payment is scheduled for <span class="bn-deduction-day">{{ deductionDay | customDateFormat }}.</span></div>
                    <div class="bn-desc-text">If you make a manual payment now, the automatic payment will be adjusted to reflect the amount paid online.</div>
                </div>
            </ng-container>
            <ng-template #notAutoPayAlert>
            <div class="bn-agent-text">A payment has already been received for this policy today.</div>
            </ng-template>
            <hr class="bn-hr-margin bn-hr-border">
            <div class="bn-agent-text">Do you want to make an additional payment?</div>
        </div>
    </div>
</div>